module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_bell-3f5e77a390189e1cb55b8c70ebb603b7.svg";